import styled from 'styled-components';

export const TopArea = styled.div`
  width: 100%;
  position: relative;
`;

export const Content = styled.div`
  display: flex;
  padding: 16px 24px;
  border-bottom: 1px solid #efefef;
`;

export const ButtonBack = styled.button`
  border-radius: 8px;
  font-weight: 500;
  display: flex;
  height: 32px;
  padding: 4px 15px;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: 1px solid #5768ff;
  cursor: pointer;
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  color: #101010;
`;
